import { Box, Button, Checkbox, Typography } from "@mui/material";
import React from "react";
import { ORDER_STATUS_TRANSLATE, orderStatusFormatted, printStatusType, RETURN_REFUND_OPTIONS_TRANSLATE } from "src/constant";
import useOrderList from "src/hooks/orders/useOrderList";
import useQueryParams from "src/hooks/useQueryParams";
import { v4 as uuid } from "uuid";
import ProcessingBadge from "src/components/shared/ProcessingBagde";

export default function usePrepareBulkBody({ total, setTotal, userMeWHouse, paramsQuery, orderState, onPrintOrder, date }) {
  const [option] = useQueryParams();

  const { data: orders } = useOrderList({
    limit: 50,
    offset: 0,
    warehouse: userMeWHouse ? userMeWHouse : option.whouseId,
    shippingProvider: paramsQuery?.shippingProvider,
    ...paramsQuery,
    ...orderState,
    ...date,
  });

  const handleSelectedAll = () => {
    if (total?.length === orders?.data?.length) {
      setTotal([]);
    } else {
      setTotal(orders?.data?.map((v) => v?._id));
    }
  };

  const handleSelectedOne = (id) => {
    if (total?.includes(id)) {
      setTotal(total?.filter((v) => v !== id));
    } else {
      setTotal([...total, id]);
    }
  };

  const header = [
    {
      id: uuid(),
      width: "80px",
      comp: (
        <Checkbox
          checked={total?.length === orders?.data?.length ? true : false}
          onClick={handleSelectedAll}
        />
      ),
    },
    {
      id: uuid(),
      title: "STT",
      width: "220px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Đơn hàng",
      width: "220px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Trạng thái",
      width: "220px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Trạng thái in",
      width: "220px",
      align: "center",
    },
    {
      id: uuid(),
      title: "ĐVVC",
      width: "220px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "220px",
      align: "center",
    },
  ];

  const bodyList = Array.isArray(orders?.data)
    ? orders?.data?.map((v, i) => ({
        ...v,
        no: i + 1,
        checkbox: (
          <Checkbox
            onClick={() => handleSelectedOne(v?._id)}
            checked={total?.includes(v?._id) ? true : false}
          />
        ),
        status: (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <ProcessingBadge
              value={ORDER_STATUS_TRANSLATE[v?.trackingStatus]}
              asset={{ color: v?.trackingStatus, text: v?.trackingStatus }}
            />
            <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>{v?.type === orderStatusFormatted.Exchange ? RETURN_REFUND_OPTIONS_TRANSLATE[v?.type] : ""}</Typography>
          </Box>
        ),
        shippingProvider: <Typography align="center">{v?.shippingProvider?.name}</Typography>,
        check: v?.isPrint ? "Đã in" : "Chưa in",
        action: (
          <Button
            onClick={() => onPrintOrder?.(v)}
            sx={{ whiteSpace: "nowrap" }}
            variant="contained"
          >
            In phiếu
          </Button>
        ),
      }))
    : [];

  const sortData = ["checkbox", "no", "code", "status", "check", "shippingProvider", "action"];
  return { header, sortData, bodyList };
}
